export default "__VITE_ASSET__CiJma__x__"